import script from "./SolutionsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionsSection.vue?vue&type=script&setup=true&lang=js"

import "./SolutionsSection.vue?vue&type=style&index=0&id=46a43242&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46a43242"]])

export default __exports__